import { useFm } from '@better-bit-fe/base-hooks';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { IRefer } from '~/types';
import { PropsWithChildren, useEffect } from 'react';

import { getUrlAfterLangChange } from '~/utils';
import styles from './index.module.less';
const { staticFolder } = getConfig().publicRuntimeConfig;

const Footer = (props: PropsWithChildren<IRefer>) => {
  const t = useFm();
  const router = useRouter();
  const gotoAboutPage = () => {
    // router.push(getUrlAfterLangChange('/aboutUs')); //...locales报错
    const url = getUrlAfterLangChange('/aboutUs');

    location.href = url;
  };
  return (
    <footer className="footer-wrapper">
      <div className="container-default w-container">
        <div className="footer-top">
          <div
            className={`w-layout-grid grid-footer-v1---4-column ${styles.gridWrapper}`}
          >
            {/* 图片 */}
            <div
              // id="w-node-e3565173-e9d2-3001-847c-69d20877c713-0877c70f"
              data-w-id="e3565173-e9d2-3001-847c-69d20877c713"
              className="footer-cta-wrapper"
            >
              <div className={`footer-cta-content-top ${styles.content}`}>
                <div className="footer-cta-content-top---wrapper">
                  <div className="inner-container _388px">
                    <h2 className="color-neutral-800 mg-bottom-24px">
                      {t('footerTitle')}
                    </h2>
                    <a
                      href="/trade/usdt/BTCUSDT"
                      className={`btn-primary color-neutral-800 w-button ${styles.btn}`}
                    >
                      {t('tradeNow')}
                    </a>
                  </div>
                </div>
              </div>
              <div className="image-wrapper footer-cta-image">
                <img
                  src={`${staticFolder}/mufex/images/footer/h5-bg.png`}
                  loading="eager"
                  className="image"
                />
              </div>
            </div>
            {/* 菜单1 */}
            <div
              // id="w-node-e3565173-e9d2-3001-847c-69d20877c71d-0877c70f"
              data-w-id="e3565173-e9d2-3001-847c-69d20877c71d"
            >
              <div className="footer-title">{t('aboutUS')}</div>
              <ul role="list" className="footer-list-wrapper">
                <li className="footer-list-item">
                  {/* <a
                    href={getUrlAfterLangChange('/aboutUs')}
                    className="footer-link"
                  >
                    {t('aboutUS')}
                  </a> */}
                  <div onClick={gotoAboutPage} className="footer-link">
                    {t('aboutUS')}
                  </div>
                </li>
                <li className="footer-list-item">
                  <a href=" https://blog.mufex.finance" className="footer-link">
                    {t('announcement')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://docs.mufex.finance/mufex/what-is-mufex/mufex-liquidity-pool"
                    className="footer-link"
                  >
                    {t('mlpToken')}
                  </a>
                </li>
                <li className="footer-list-item last">
                  <a
                    href="https://docs.mufex.finance/mufex/support/mufex-affiliate-program"
                    className="footer-link"
                  >
                    {t('affiliateProgram')}
                  </a>
                </li>
              </ul>
            </div>
            {/* 菜单2 */}
            <div data-w-id="e3565173-e9d2-3001-847c-69d20877c74e">
              <div className="footer-title">{t('helpCenter')}</div>
              <ul role="list" className="footer-list-wrapper">
                <li className="footer-list-item">
                  <a
                    href=" https://docs.mufex.finance/mufex/start-using-mufex/trading/contract-specs"
                    className="footer-link"
                  >
                    {t('perpetualDerivatives')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href=" https://docs.mufex.finance/mufex/start-using-mufex/fee-rates"
                    className="footer-link"
                  >
                    {t('feeRate')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://docs.mufex.finance/mufex/start-using-mufex/trading/trading-rules"
                    className="footer-link"
                  >
                    {t('tradingRules')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://www.mufex.finance/apidocs/derivatives/contract/index.html#t-authentication"
                    className="footer-link"
                  >
                    API
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://docs.mufex.finance/mufex/support/faq"
                    className="footer-link"
                  >
                    {t('FAQ')}
                  </a>
                </li>
                <li className="footer-list-item last">
                  <a
                    href="mailto:support@mufex.finance"
                    className="footer-link"
                  >
                    {t('feedback')}
                  </a>
                </li>
              </ul>
            </div>
            {/* 菜单3 */}
            <div data-w-id="e3565173-e9d2-3001-847c-69d20877c75e">
              <div className="footer-title">{t('followUs')}</div>
              <ul role="list" className="footer-list-wrapper">
                <li className="footer-list-item">
                  <a
                    href="https://twitter.com/mufex_Official/"
                    className={`footer-link ${styles.socialwrapper}`}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        className={styles.socialBase}
                        width="24"
                        height="24"
                        rx="8"
                        fill="white"
                      />
                      <path
                        d="M14.3544 6.32332V6.3208H15.0108L15.2507 6.36871C15.4106 6.39981 15.5558 6.44056 15.6862 6.49099C15.8167 6.54141 15.9429 6.60025 16.0649 6.66748C16.187 6.73471 16.2976 6.80321 16.3969 6.87297C16.4954 6.94189 16.5838 7.015 16.6621 7.09232C16.7395 7.17048 16.8602 7.19065 17.0243 7.15283C17.1885 7.11501 17.3652 7.06248 17.5546 6.99525C17.7439 6.92802 17.9312 6.85238 18.1163 6.76833C18.3015 6.68428 18.4143 6.63092 18.4547 6.60823C18.4942 6.58471 18.5153 6.5721 18.5178 6.57041L18.5203 6.56663L18.5329 6.56032L18.5455 6.55402L18.5582 6.54772L18.5708 6.54141L18.5733 6.53763L18.5771 6.53511L18.5809 6.53259L18.5834 6.52881L18.596 6.52503L18.6087 6.52251L18.6061 6.54141L18.6023 6.56032L18.596 6.57923L18.5897 6.59814L18.5834 6.61075L18.5771 6.62336L18.5708 6.64227C18.5666 6.65487 18.5624 6.67168 18.5582 6.69269C18.554 6.71371 18.514 6.79774 18.4382 6.94482C18.3625 7.0919 18.2678 7.24108 18.1542 7.39236C18.0406 7.54363 17.9388 7.65792 17.8487 7.73525C17.7578 7.81341 17.6976 7.86804 17.6682 7.89914C17.6387 7.93107 17.603 7.96048 17.5609 7.98738L17.4977 8.02899L17.4851 8.03529L17.4725 8.04159L17.47 8.04537L17.4662 8.04789L17.4624 8.05042L17.4599 8.0542L17.4472 8.0605L17.4346 8.0668L17.4321 8.07059L17.4283 8.07311L17.4245 8.07563L17.422 8.07941L17.4195 8.08319L17.4157 8.08571L17.4119 8.08824L17.4094 8.09202H17.4725L17.826 8.01638C18.0616 7.96595 18.2867 7.90503 18.5014 7.83358L18.8422 7.72013L18.8801 7.70752L18.899 7.70122L18.9116 7.69491L18.9243 7.68861L18.9369 7.68231L18.9495 7.676L18.9748 7.67222L19 7.6697V7.69491L18.9937 7.69743L18.9874 7.70122L18.9849 7.705L18.9811 7.70752L18.9773 7.71004L18.9748 7.71382L18.9722 7.7176L18.9684 7.72013L18.9647 7.72265L18.9621 7.72643L18.9596 7.73021L18.9558 7.73273L18.9495 7.74534L18.9432 7.75794L18.9394 7.76047C18.9377 7.76299 18.8843 7.83442 18.7791 7.97478C18.6739 8.11597 18.6171 8.1874 18.6087 8.18909C18.6002 8.19161 18.5885 8.20422 18.5733 8.22691C18.559 8.25043 18.4698 8.34415 18.3057 8.50803C18.1416 8.67192 17.9808 8.81772 17.8235 8.94548C17.6652 9.07407 17.5853 9.23206 17.5836 9.41948C17.5811 9.60606 17.5714 9.81702 17.5546 10.0523C17.5377 10.2877 17.5062 10.5419 17.4599 10.815C17.4136 11.0882 17.3421 11.397 17.2453 11.7416C17.1485 12.0862 17.0307 12.4224 16.8918 12.7501C16.7529 13.0779 16.6078 13.372 16.4563 13.6326C16.3048 13.8931 16.1659 14.1137 16.0397 14.2944C15.9134 14.4751 15.7851 14.6453 15.6546 14.805C15.5242 14.9647 15.3593 15.1445 15.1598 15.3446C14.9595 15.5437 14.8501 15.653 14.8316 15.6723C14.8122 15.6908 14.7297 15.7597 14.5841 15.8791C14.4394 15.9992 14.2837 16.1194 14.117 16.2396C13.9513 16.359 13.7989 16.4586 13.6601 16.5384C13.5212 16.6182 13.3537 16.7094 13.1576 16.812C12.9624 16.9153 12.7511 17.0111 12.5239 17.0994C12.2967 17.1876 12.0568 17.2696 11.8043 17.3452C11.5518 17.4208 11.3078 17.4797 11.0721 17.5217C10.8365 17.5637 10.5693 17.5994 10.2705 17.6289L9.82236 17.673V17.6793H9.0018V17.673L8.8945 17.6667C8.82297 17.6625 8.76406 17.6583 8.71776 17.6541C8.67148 17.6499 8.49684 17.6267 8.19387 17.5847C7.89089 17.5427 7.65315 17.5007 7.48061 17.4587C7.30809 17.4166 7.0514 17.3368 6.71055 17.2191C6.3697 17.1015 6.07809 16.9826 5.83571 16.8624C5.59417 16.743 5.44269 16.6674 5.38124 16.6355C5.32065 16.6044 5.25248 16.5657 5.17674 16.5195L5.06312 16.4501L5.06061 16.4464L5.05681 16.4438L5.05302 16.4413L5.0505 16.4375L5.03787 16.4312L5.02525 16.4249L5.02274 16.4211L5.01894 16.4186L5.01515 16.4161L5.01262 16.4123L5.01011 16.4085L5.00631 16.406H5V16.3808L5.01262 16.3833L5.02525 16.3871L5.08206 16.3934C5.11993 16.3976 5.22303 16.4039 5.39134 16.4123C5.55967 16.4207 5.7385 16.4207 5.92786 16.4123C6.11722 16.4039 6.3108 16.385 6.50857 16.3556C6.70635 16.3262 6.93989 16.2758 7.2092 16.2043C7.47852 16.1329 7.72595 16.048 7.9515 15.9497C8.17621 15.8505 8.3361 15.7765 8.43121 15.7278C8.52546 15.6799 8.66938 15.5908 8.86294 15.4605L9.15329 15.2651L9.15582 15.2613L9.1596 15.2588L9.1634 15.2563L9.16592 15.2525L9.16844 15.2487L9.17223 15.2462L9.17603 15.2437L9.17854 15.2399L9.19116 15.2361L9.20379 15.2336L9.20631 15.221L9.2101 15.2084L9.2139 15.2059L9.21641 15.2021L9.11542 15.1958C9.0481 15.1916 8.98287 15.1874 8.91975 15.1832C8.85663 15.179 8.75774 15.1601 8.62308 15.1265C8.48844 15.0928 8.34326 15.0424 8.18756 14.9752C8.03186 14.908 7.88038 14.8281 7.73309 14.7357C7.58582 14.6432 7.47935 14.5663 7.41371 14.505C7.34891 14.4444 7.26474 14.3587 7.16123 14.2478C7.05856 14.136 6.96934 14.0213 6.8936 13.9036C6.81785 13.786 6.74548 13.6502 6.67648 13.4964L6.57169 13.267L6.56537 13.2481L6.55906 13.2292L6.55527 13.2166L6.55275 13.204L6.57169 13.2065L6.59062 13.2103L6.72949 13.2292C6.82207 13.2418 6.96725 13.246 7.16501 13.2418C7.36279 13.2376 7.49955 13.2292 7.57529 13.2166C7.65104 13.204 7.69733 13.1956 7.71416 13.1914L7.7394 13.1851L7.77096 13.1788L7.80252 13.1724L7.80505 13.1687L7.80884 13.1661L7.81264 13.1636L7.81515 13.1598L7.7899 13.1535L7.76465 13.1472L7.7394 13.1409L7.71416 13.1346L7.68891 13.1283C7.67208 13.1241 7.64263 13.1157 7.60054 13.1031C7.55847 13.0905 7.44485 13.0443 7.25969 12.9644C7.07455 12.8846 6.92727 12.8069 6.81785 12.7312C6.70817 12.6554 6.60359 12.5724 6.50478 12.4829C6.40631 12.3921 6.29817 12.2753 6.18034 12.1324C6.06252 11.9895 5.95733 11.8235 5.86474 11.6345C5.77217 11.4454 5.70274 11.2647 5.65645 11.0924C5.61034 10.9211 5.57992 10.746 5.56557 10.5692L5.54283 10.3045L5.55546 10.307L5.56808 10.3108L5.5807 10.3171L5.59333 10.3234L5.60595 10.3297L5.61858 10.336L5.81425 10.4242C5.9447 10.4831 6.10671 10.5335 6.30027 10.5755C6.49385 10.6175 6.60956 10.6406 6.64743 10.6448L6.70424 10.6511H6.81785L6.81534 10.6474L6.81154 10.6448L6.80775 10.6423L6.80523 10.6385L6.80272 10.6348L6.79892 10.6322L6.79513 10.6297L6.79261 10.6259L6.77998 10.6196L6.76736 10.6133L6.76485 10.6095L6.76105 10.607L6.75726 10.6045L6.75473 10.6007L6.74211 10.5944L6.72949 10.5881L6.72697 10.5843C6.72445 10.5826 6.68826 10.5557 6.61839 10.5036C6.54938 10.4507 6.47701 10.3822 6.40126 10.2982C6.32552 10.2141 6.24977 10.1259 6.17403 10.0334C6.09815 9.94077 6.03056 9.84164 5.97205 9.73717C5.91314 9.63212 5.85086 9.49848 5.78521 9.33628C5.72041 9.17492 5.67118 9.01229 5.63751 8.84841C5.60386 8.68452 5.58492 8.52274 5.5807 8.36306C5.5765 8.20337 5.5807 8.0668 5.59333 7.95335C5.60595 7.83989 5.6312 7.71172 5.66907 7.56885C5.70694 7.42598 5.76166 7.2747 5.83318 7.11501L5.94049 6.87549L5.9468 6.85658L5.95311 6.83767L5.95691 6.83515L5.95942 6.83137L5.96195 6.82758L5.96573 6.82506L5.96953 6.82758L5.97205 6.83137L5.97457 6.83515L5.97836 6.83767L5.98216 6.84019L5.98467 6.84397L5.9872 6.84775L5.99098 6.85027L5.99729 6.86288L6.00361 6.87549L6.00741 6.87801L6.00992 6.88179L6.18034 7.07089C6.29396 7.19695 6.42862 7.33773 6.58431 7.49321C6.74001 7.64868 6.82627 7.72937 6.8431 7.73525C6.85994 7.74197 6.88097 7.7613 6.90622 7.79324C6.93147 7.82434 7.01563 7.89872 7.1587 8.01638C7.30178 8.13404 7.48903 8.27061 7.72047 8.42609C7.95192 8.58157 8.2086 8.73495 8.49053 8.88623C8.77248 9.03751 9.07545 9.17407 9.39946 9.29594C9.72348 9.41781 9.95071 9.49765 10.0812 9.53546C10.2116 9.57328 10.4346 9.62161 10.7502 9.68044C11.0658 9.73927 11.3036 9.77709 11.4635 9.7939C11.6234 9.8107 11.7328 9.82037 11.7917 9.82289L11.8801 9.82541L11.8776 9.80651L11.8738 9.7876L11.8485 9.63001C11.8317 9.52496 11.8233 9.37788 11.8233 9.18879C11.8233 8.99969 11.838 8.8253 11.8674 8.66561C11.8969 8.50593 11.9411 8.34415 12 8.18026C12.0589 8.01638 12.1166 7.88484 12.1729 7.78568C12.2302 7.68735 12.3051 7.57515 12.3977 7.44908C12.4902 7.32302 12.6102 7.19276 12.7574 7.05828C12.9047 6.92381 13.073 6.80405 13.2624 6.699C13.4518 6.59395 13.6264 6.5141 13.7863 6.45947C13.9462 6.40485 14.0809 6.36912 14.1903 6.35232C14.2997 6.33551 14.3544 6.32584 14.3544 6.32332Z"
                        fill="black"
                      />
                    </svg>
                    {t('twitter')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://t.me/mufex"
                    className={`footer-link ${styles.socialwrapper}`}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        className={styles.socialBase}
                        width="24"
                        height="24"
                        rx="8"
                        fill="white"
                      />
                      <path
                        d="M4.54635 11.2081C4.54635 11.2081 11.1145 8.51253 13.3925 7.56335C14.2657 7.1837 17.2271 5.96875 17.2271 5.96875C17.2271 5.96875 18.5939 5.43725 18.48 6.72808C18.442 7.25963 18.1383 9.11995 17.8346 11.1322C17.379 13.9797 16.8854 17.0929 16.8854 17.0929C16.8854 17.0929 16.8095 17.9661 16.1641 18.118C15.5186 18.2699 14.4555 17.5865 14.2657 17.4346C14.1138 17.3207 11.4182 15.6122 10.4311 14.7769C10.1654 14.5492 9.86164 14.0936 10.4691 13.562C11.8359 12.3091 13.4684 10.7525 14.4555 9.76542C14.9112 9.3098 15.3667 8.24675 13.4684 9.53759C10.7728 11.398 8.11519 13.1444 8.11519 13.1444C8.11519 13.1444 7.50771 13.5241 6.36873 13.1824C5.2297 12.8407 3.90088 12.3851 3.90088 12.3851C3.90088 12.3851 2.98974 11.8156 4.54635 11.2081Z"
                        fill="black"
                      />
                    </svg>
                    {t('telegram')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://discord.com/invite/m6DD42s46n"
                    className={`footer-link ${styles.socialwrapper}`}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        className={styles.socialBase}
                        width="24"
                        height="24"
                        rx="8"
                        fill="white"
                      />
                      <path
                        d="M17.463 7.02731C19.2367 9.63525 20.1127 12.5769 19.7853 15.9635C19.7839 15.9778 19.7764 15.991 19.7647 15.9996C18.4214 16.9859 17.12 17.5845 15.8368 17.9815C15.8268 17.9845 15.8162 17.9844 15.8063 17.981C15.7964 17.9777 15.7878 17.9713 15.7817 17.9628C15.4852 17.5504 15.2159 17.1155 14.9799 16.6589C14.9663 16.632 14.9787 16.5996 15.0066 16.589C15.4344 16.4278 15.8412 16.2346 16.2324 16.0059C16.2632 15.9878 16.2652 15.9437 16.2367 15.9225C16.1537 15.8608 16.0714 15.796 15.9927 15.7312C15.978 15.7193 15.9582 15.7169 15.9415 15.725C13.4013 16.898 10.6186 16.898 8.04835 15.725C8.03166 15.7175 8.01183 15.7201 7.9975 15.7318C7.91897 15.7966 7.83652 15.8608 7.75426 15.9225C7.72579 15.9437 7.72815 15.9878 7.75917 16.0059C8.15044 16.2303 8.55721 16.4278 8.98441 16.5898C9.01209 16.6004 9.02525 16.632 9.0115 16.6589C8.78063 17.1161 8.51128 17.551 8.20933 17.9634C8.19618 17.9801 8.17458 17.9878 8.15417 17.9815C6.87709 17.5845 5.57567 16.9859 4.23244 15.9996C4.22125 15.991 4.2132 15.9772 4.21202 15.9629C3.93835 13.0336 4.4961 10.0676 6.53215 7.02672C6.53706 7.01867 6.54452 7.01239 6.55316 7.00866C7.55499 6.54887 8.62828 6.21061 9.75007 6.01743C9.77048 6.01429 9.7909 6.02371 9.8015 6.04177C9.94011 6.28718 10.0985 6.60188 10.2057 6.85906C11.3882 6.67845 12.5891 6.67845 13.7963 6.85906C13.9035 6.60738 14.0564 6.28718 14.1944 6.04177C14.1993 6.03281 14.2069 6.02563 14.2162 6.02126C14.2254 6.01689 14.2358 6.01555 14.2458 6.01743C15.3682 6.2112 16.4415 6.54946 17.4426 7.00866C17.4514 7.01239 17.4587 7.01867 17.463 7.02731ZM10.8069 12.597C10.8192 11.731 10.1879 11.0144 9.39531 11.0144C8.60924 11.0144 7.98395 11.7247 7.98395 12.597C7.98395 13.469 8.62161 14.1793 9.39531 14.1793C10.1816 14.1793 10.8069 13.469 10.8069 12.597ZM16.0255 12.597C16.0379 11.731 15.4065 11.0144 14.6141 11.0144C13.8279 11.0144 13.2026 11.7247 13.2026 12.597C13.2026 13.469 13.8402 14.1793 14.6141 14.1793C15.4065 14.1793 16.0255 13.469 16.0255 12.597Z"
                        fill="black"
                      />
                    </svg>
                    {t('discord')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://www.youtube.com/channel/UC0VQ8_HuC8yeiJvEbrfmRqw"
                    className={`footer-link ${styles.socialwrapper}`}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        className={styles.socialBase}
                        width="24"
                        height="24"
                        rx="8"
                        fill="white"
                      />
                      <path
                        d="M12.3102 16.9354L9.4379 16.8817C8.50793 16.863 7.57564 16.9003 6.6639 16.7065C5.27694 16.417 5.17868 14.9972 5.07587 13.8063C4.9342 12.1321 4.98904 10.4275 5.25639 8.76724C5.40732 7.83566 6.00128 7.27978 6.91982 7.21929C10.0206 6.99976 13.1419 7.02578 16.2358 7.1282C16.5626 7.13759 16.8916 7.1889 17.2138 7.24731C18.8042 7.53221 18.843 9.14107 18.9461 10.4954C19.0489 11.8638 19.0055 13.2391 18.809 14.5982C18.6513 15.7234 18.3497 16.667 17.0767 16.7581C15.4817 16.8772 13.9233 16.9731 12.3238 16.9426C12.3239 16.9354 12.3147 16.9354 12.3102 16.9354ZM10.6216 14.0866C11.8235 13.3813 13.0025 12.6879 14.1976 11.9873C12.9934 11.2821 11.8166 10.5886 10.6216 9.8881V14.0866Z"
                        fill="black"
                      />
                    </svg>
                    {t('youtube')}
                  </a>
                </li>
                <li className="footer-list-item">
                  <a
                    href="https://blog.mufex.finance/"
                    className={`footer-link ${styles.socialwrapper}`}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        className={styles.socialBase}
                        width="24"
                        height="24"
                        rx="8"
                        fill="white"
                      />
                      <g clipPath="url(#clip0_2307_26905)">
                        <path
                          d="M12.8968 11.9998C12.8968 14.1954 11.1291 15.9754 8.94834 15.9754C6.76763 15.9754 5 14.196 5 11.9998C5 9.8037 6.76777 8.02441 8.94834 8.02441C11.1289 8.02441 12.8968 9.80424 12.8968 11.9998ZM17.2283 11.9998C17.2283 14.0667 16.3444 15.7421 15.2541 15.7421C14.1638 15.7421 13.2799 14.0662 13.2799 11.9998C13.2799 9.93349 14.1638 8.25757 15.2541 8.25757C16.3444 8.25757 17.2283 9.93349 17.2283 11.9998ZM19 11.9998C19 13.8517 18.6891 15.3527 18.3056 15.3527C17.9222 15.3527 17.6113 13.8511 17.6113 11.9998C17.6113 10.1485 17.9222 8.64692 18.3058 8.64692C18.6894 8.64692 19 10.1481 19 11.9998Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_2307_26905">
                          <rect
                            className={styles.socialBase}
                            width="14"
                            height="14"
                            fill="white"
                            transform="translate(5 5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    {t('medium')}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div
        data-w-id="e3565173-e9d2-3001-847c-69d20877c774"
        className="divider _0px"
      ></div>
      <div className="container-default w-container">
        <div className="footer-bottom">
          <div
            data-w-id="e3565173-e9d2-3001-847c-69d20877c777"
            className="grid-footer-bottom-v1"
          >
            <a href="/" className="footer-logo-link w-inline-block">
              <img
                src={`${staticFolder}/mufex/images/header/logo.svg`}
                loading="eager"
                alt="MUFEX-LOGO"
              />
            </a>
            <p className="mg-bottom-0 copy-right-color">
              Copyright© DLT Limited. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
